// Internal modules
import { appStore } from '@/store';
import { $logger, once } from '@/lib';

// Only log to FPTI the first time the user click the show cart button
const logShowCartOnce = once(() => {
  const {
    api: { cartDetails },
  } = appStore.getState();
  const { items = [], amounts = {} } = cartDetails;
  const { total = {} } = amounts;

  $logger.fpti('weasley_show_cart_dropdown', {
    amt: total.currencyFormat,
    currency_code: total.currencyCode,
    pu_item_cnt: items.length,
    state_name: 'BILLING',
    transition_name: 'clicked_item_cart',
  });
});

export { logShowCartOnce };
